import { useClickActionContext } from 'components/Widget/context/ClickActionContext';
import { useCallback } from 'react';

export function usePostClickableEntities({
    permalink,
    clickableUrls,
    profilePermalink,
}: {
    permalink?: string;
    clickableUrls?: boolean;
    profilePermalink?: string;
}) {
    const { onEntityClick } = useClickActionContext();

    const handlePermalinkClick = useCallback(
        event => {
            if (onEntityClick && clickableUrls && permalink) {
                onEntityClick({
                    event,
                    url: permalink,
                });
            }
        },
        [clickableUrls, onEntityClick, permalink]
    );

    const handleChannelClick = useCallback(
        event => {
            if (onEntityClick && clickableUrls && permalink) {
                onEntityClick({
                    event,
                    url: permalink,
                });
            }
        },
        [clickableUrls, onEntityClick, permalink]
    );

    const handleProfileClick = useCallback(
        event => {
            if (onEntityClick && clickableUrls && profilePermalink) {
                onEntityClick({
                    event,
                    url: profilePermalink,
                });
            }
        },
        [clickableUrls, onEntityClick, profilePermalink]
    );

    return {
        handlePermalinkClick,
        handleChannelClick,
        handleProfileClick,
    };
}
